riot.tag2('loader', '<code><pre name="code">\n    </pre></code> <div name="legend"> </div> <div name="yield"><yield></div>', '', '', function(opts) {
    this.json = this.yield.innerHTML

    this.on('mount', () => {
        this.prism = require('prismjs')
        this.code.innerHTML = this.prism.highlight(this.json, this.prism.languages.js)
        this.yield.hidden = true
    })

    this.toJSON = (json) => {
        var jsonString = json

          .replace(/([\$\w]+)\s*:/g, (_, $1) => {return '"'+$1+'":'})

          .replace(/(\/.+\/)/g, (_, $1) => {return '"'+$1+'":'})

          .replace(/'([^']+)'/g, (_, $1) => {return '"'+$1+'"'})

        return JSON.parse(jsonString)
    }

});



/** WEBPACK FOOTER **
 ** ./js/tags/loader.html
 **/